import React, { useState } from "react";
import CTable from "components/common/Table";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Grid from "components/common/Grid";
import IconButton from "components/common/IconButton";
import Stack from "components/common/Stack";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Avatar from "components/common/Avatar";
import MenuItem from "components/common/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Link from "components/common/Link";
import { withRouter } from "react-router";
import InputLabel from "@mui/material/InputLabel";
import Paper from "components/common/Paper";

const CustomersTable = ({ props, onChange, formData, isLoading }) => {
  const classes = useStyles();
  var Data = props.customerTableData;
  var vehModels = props.vehicleMasterData;
  var vendorname = props.VendorNameData;
  var locationDatas = props.locationData;
  var manufacturerDatas = props.manufacturerData;

  const columns = [
    {
      field: "clientName",
      headerName: "Name of Customer",
      valueGetter: (v, d) => {
        const customer = {
          pathname: `/customer/details/` + d.customerId,
          customerId: d.customerId,
        };
        return (
          <>
            <Grid container spacing={0}>
              <Stack direction="row" spacing={0}>
                <Avatar
                  sx={{
                    width: 30,
                    height: 30,
                    marginRight: "0.5rem",
                  }}
                  src={d.clientImage}
                  variant="body1"
                  title="F"
                ></Avatar>

                <Grid item xs={12}>
                  <Link href={customer} color="inherit" underline="hover">
                    <Text sx={{ fontSize: "14px", marginTop: "5px" }}>{v}</Text>
                  </Link>
                </Grid>
              </Stack>
            </Grid>
          </>
        );
      },
    },
    {
      field: "type_of_customers",
      headerName: "Type of Customer ",
    },
    {
      field: "power_consumed",
      headerName: "Power Consumed",
      valueGetter: (v, d) => {
        return (
          <>
            <Grid container spacing={0}>
              <Stack direction="row" spacing={0}>
                <Grid item xs={12}>
                  <Text sx={{ fontSize: "13px" }} color="#707070">
                    {d.power_consumed} kw
                  </Text>
                </Grid>
              </Stack>
            </Grid>
          </>
        );
      },
    },
    {
      field: "time_spent",
      headerName: "Time Spent",
    },
    {
      field: "amount_paid",
      headerName: "Amount Paid",
      valueGetter: (v, d) => {
       
        return (
          <>
            <Grid container spacing={0}>
              <Stack direction="row" spacing={0}>
                <Grid item xs={12}>
                  <Text sx={{ fontSize: "13px" }} color="#707070">
                    &#8377; {d.amount_paid}
                  </Text>
                </Grid>
              </Stack>
            </Grid>
          </>
        );
      },
    },
  ];
  const [inputText, setInputText] = useState("");
  let inputSearchHandler = (e) => {
    //convert input text to lower case
    var lowerCase = e.toLowerCase();
    setInputText(lowerCase);
  };
  ///
 
  const filteredData = Data.filter((el) => {
    //if no input the return the original
    if (inputText === "") {
      return el;
    }
    //return the item which contains the user input
    else {
      return el.clientName?.toLowerCase().includes(inputText);
    }
  });
  ///////////

  return (
    <Box className={classes.center} sx={{ marginTop: "1.6rem" }}>
      <Card>
        <CardContent>
          <Text className={classes.pageHeading}>CUSTOMERS</Text>

          <Stack
            direction={{ sm: "column", xs: "column", md: "row" }}
            spacing={2}
            justifyContent="space-between"
            sx={{
              marginBottom: "11px",
            }}
          >
            <Stack
              direction={{ sm: "column", xs: "column", md: "row" }}
              spacing={2}
            >
              <Box sx={{ maxWidth: 120, minWidth: 120 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                    Vendor
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="location-label"
                    label="vendor"
                    className={classes.table_location}
                    value={formData.vendor_id ? formData.vendor_id : "All"}
                    onChange={(e) => onChange("vendor_id", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} selected value="All">
                      All
                    </MenuItem>
                    {vendorname.map((ven) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={ven.vendor_id}
                        value={ven.vendor_id}
                      >
                        {ven.vendors_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                    Location
                  </InputLabel>
                  <Select
                    labelId="location-label"
                    label="Location"
                    className={classes.customer}
                    sx={{ width: "140px", height: "36px", fontSize: "14px" }}
                    value={formData.station_id ? formData.station_id : "all"}
                    onChange={(e) => onChange("station_id", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} selected value={"all"}>
                      All
                    </MenuItem>
                    {locationDatas.map((locs) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={locs.id}
                        value={locs.id}
                      >
                        {locs.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="manufacturer-label">
                    Manufacturer
                  </InputLabel>
                  <Select
                    labelId="manufacturer-label"
                    label="Manufacturer"
                    className={classes.customer}
                    sx={{ width: "140px", height: "36px", fontSize: "14px" }}
                    value={
                      formData.manufacturer_id
                        ? formData.manufacturer_id
                        : "all"
                    }
                    onChange={(e) =>
                      onChange("manufacturer_id", e.target.value)
                    }
                  >
                    <MenuItem sx={{ fontSize: "14px" }} value={"all"}>
                      All
                    </MenuItem>
                    {manufacturerDatas.map((manufacturers) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={manufacturers.id}
                        value={manufacturers.id}
                      >
                        {manufacturers.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="model-label">
                    Model
                  </InputLabel>
                  <Select
                    labelId="model-label"
                    label="Model"
                    className={classes.customer}
                    sx={{ width: "140px", height: "36px", fontSize: "14px" }}
                    value={formData.model_id ? formData.model_id : "all"}
                    onChange={(e) => onChange("model_id", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} value={"all"}>
                      All
                    </MenuItem>
                    {vehModels.map((modls) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={modls.id}
                        value={modls.id}
                      >
                        {modls.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
            <Grid>
              <Box
                sx={{
                  textAlign: "right",
                  alignContent: "flex-end",
                  borderRadius: "5px !important",
                }}
              >
                <Paper
                  sx={{
                    p: "2px 0",
                    display: "flex",
                    alignItems: "center",
                    width: "273px",
                    height: "32px",
                  }}
                >
                  <IconButton sx={{ p: "8px" }} aria-label="search">
                    <SearchIcon />
                  </IconButton>
                  <InputBase
                    sx={{ ml: 1, flex: 1, fontSize: "16px", fontWeight: "500" }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "search" }}
                    onChange={(e) => inputSearchHandler(e.target.value)}
                  />
                </Paper>
              </Box>
            </Grid>
          </Stack>

          <CTable
            columns={columns}
            data={filteredData}
            isLoading={isLoading}
            pagination={true}
            localPagination={true}
            page={0}
            rowsPerPage={5}
          ></CTable>
        </CardContent>
      </Card>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  viewButtonLabel: { textTransform: "none" },
  pageHeading: {
    fontSize: "22px",
    marginBottom: "2.5rem",
    textTransform: "none",
    color: "#707070",
    opacity: 1,
  },
  customer: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
}));

export default withRouter(CustomersTable);
